import { baseApi } from '@ibk/shared-config';
export var OpenFinanceVersion;
(function (OpenFinanceVersion) {
    OpenFinanceVersion["V1"] = "v1";
    OpenFinanceVersion["V2"] = "v2";
})(OpenFinanceVersion || (OpenFinanceVersion = {}));
export const openFinanceApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getConsentsBanks: builder.query({
            query: ({ partyId, version = 'v1' }) => {
                const url = version === 'v1' ? `/v1/open-banking/consents/banks/${partyId}` : `/v2/open-banking/consents/${partyId}`;
                return {
                    url: url,
                    method: 'GET',
                };
            },
            providesTags: ['ConsentBanks'],
        }),
        prefill: builder.mutation({
            query: body => ({
                url: '/v1/open-banking/consents/prefill',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Base'],
        }),
        createBelvoToken: builder.mutation({
            query: body => ({
                url: '/v1/open-banking/belvo/token',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Base'],
        }),
        createPluggyToken: builder.mutation({
            query: body => ({
                url: '/v1/open-banking/auth/token',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Base'],
        }),
        invalidateConsent: builder.mutation({
            query: body => ({
                url: '/v1/open-banking/consents/invalidate',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['ConsentBanks'],
        }),
        getConsentTransactions: builder.query({
            query: ({ accountId, query }) => {
                return {
                    url: `/v2/open-banking/consents/accounts/${accountId}/transactions`,
                    method: 'GET',
                    params: query,
                };
            },
            providesTags: ['Base'],
            keepUnusedDataFor: 0,
        }),
    }),
    overrideExisting: false,
});
export const { useGetConsentsBanksQuery, useCreateBelvoTokenMutation, useCreatePluggyTokenMutation, usePrefillMutation, useInvalidateConsentMutation, useGetConsentTransactionsQuery, } = openFinanceApi;
